<template>
  <div class="news">
    <div class="banner">
      <el-image :src="image.url"/>
    </div>
    <div class="tags">
      <h3>新闻类别：</h3>
      <el-tag
        @click="clickTag(tag,index)"
        @close="closeTag(tag,index)"
        v-for="(tag,index) in tags"
        :key="tag.name"
        closable
        :type="tag.type">
        {{ tag.name }}
      </el-tag>
    </div>
    <div class="newsCard">
      <el-row :gutter="20">
        <el-col :span="6" :xs="24" :sm="12" :md="8" :xl="6" v-for="item in articles" :key="item.id">
          <el-card shadow="hover" :body-style="{ padding: '0px' }">
            <el-image :src="item.img" class="image"/>
            <div class="content">
              <span :title="item.title">{{ item.title }}</span>
              <div class="bottom clearfix">
                <time class="time">{{ item.date|formatDate(item.date) }}</time>
                <el-button type="text" class="button" @click="openNewPage(item)">查看详情</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="pagination">
      <el-pagination
        background
        :small="small"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        hide-on-single-page
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { NewsMixin } from '../../mixins/NewsMixin'

export default {
  name: 'NewsPage',
  mixins: [NewsMixin],
  data () {
    return {
      small: false,
      image: { url: require('../../assets/images/news/新闻中心.jpg') },
      tags: [
        {
          name: '公司新闻',
          type: 'info',
          tag: '公司新闻',
          keywords: '公司,智充'
        },
        {
          name: '行业动态',
          type: 'info',
          tag: '2'
        },
        {
          name: '新能源政策',
          type: 'info',
          tag: '政策'
        }
      ]
    }
  },
  mounted () {
    this.getArticles()
    window.addEventListener('resize', this.resizePage)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizePage)
  },
  methods: {
    clickTag (tag, index) {
      // eslint-disable-next-line no-return-assign
      this.tags.map(item => item.title = 'info')
      this.tags[index].type = 'success'
    },
    closeTag (tag, index) {
      this.tags[index].type = 'info'
      this.tmpArticles = this.articles
    },
    resizePage () {
      const width = document.documentElement.clientWidth
      if (width < 770) {
        this.small = true
      } else {
        this.small = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.news {
  //background-color:red;
  .tags {
    display: flex;
    flex-direction: row;
    margin: 2% 0 0 5%;
    padding-left: 5%;

    h3 {
      margin: 0 0 0 0;
      width: 100px;
    }

    /deep/ .el-tag {
      margin: 0 5px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .newsCard {
    // background-color:yellow;
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 0 0 4%;
    margin: 0 5%;
    max-height: 1000px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none
    }

    &::-webkit-scrollbar-track {
      background-color: #ffffff;
      -webkit-border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
      box-shadow: inset 0 0 6px rgb(63, 157, 254, 0);
      -webkit-border-radius: 5px;
    }

    .el-row {
      display: flex;
      flex-wrap: wrap;

      .el-col {
        margin: 5px 0 0 0;

        .el-card {
          min-width: 100%;
          height: 100%;
          margin-right: 20px;
          transition: all .5s;

          .content {
            margin: 14px;

            span {
              white-space: nowrap;
              text-overflow: ellipsis;
              display: block;
              margin-right: 5%;
              max-width: 307px;
              overflow: hidden;
            }

            .bottom {
              margin-top: 13px;
              line-height: 12px;

              .time {
                float: left;
                font-size: 13px;
                color: #999;
              }

              .button {
                padding-right: 0;
                float: right;
              }
            }
          }
        }
      }
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both
    }
  }

  .pagination {
    width: 90%;
    margin: 20px 8% 20px 5%;
    height: 30px;

    /deep/ .el-pagination {
      float: right;
    }
  }
}

</style>
